import type { Club } from "../../clubs/shared/types/club";

export function buildClubStreetLine(club: Club) {
  return [club.address, club.number, club.neighborhood]
    .map((item) => String(item || "").trim())
    .filter(Boolean)
    .join(" - ");
}

export function buildClubLocality(club: Club) {
  return [club.city, club.state]
    .map((item) => String(item || "").trim())
    .filter(Boolean)
    .join("/");
}

export function buildEventAddressValue(club: Club) {
  return [club.name, buildClubStreetLine(club)].filter(Boolean).join(" - ");
}

export function buildCategoryAddressValue(club: Club) {
  return [club.name, buildClubStreetLine(club), buildClubLocality(club)]
    .filter(Boolean)
    .join(" - ");
}

export function buildClubSummary(club: Club) {
  return [buildClubStreetLine(club), buildClubLocality(club)]
    .filter(Boolean)
    .join(" - ");
}
